import {USER_PROFILE} from "@/api/user"
import { Toast } from 'vant';
import Vue from 'vue';

const profile = (callback) => {
    let _this = this;
    Vue.prototype.$reqGet(USER_PROFILE).then(res => {
      getSuccess(res, callback)
    }).catch(err => {
      getSuccess(err, callback)
    })
}

let getSuccess = (res, callback) => {
  if(!res.data){
    return;
  }
  if(res.data.code != 0){
    let msg = (res.data && res.data.msg) ? res.data.msg : "加载用户资料失败";
    Toast.fail(msg);
    return;
  }
  const data = res.data.data;
  callback(data);
}



export default {
  install(Vue) {
    Object.defineProperties(Vue.prototype, {
      $user:{
        value: {
          profile
        }
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/pull.js